<template>
    <div class="input-item">
        <label class="label" for="identificationNumber">IČO {{!required || icOptional ? '(nepovinné)' : ''}}</label>
        <input class="input input--l" id="identificationNumber" type="text" v-model="identificationNumber" v-on:blur="loadAresData()">
        <button class="button button--link button--ares" v-on:click="loadAresData()" v-if="disableAres === false">
            {{processing ? 'Načítám...' : 'Načíst údaje z ARESu'}}
        </button>
        <ssv-order-error-field field="billingInformation.identificationNumber"/>
        <div class="clearfix"></div>
        <template v-if="false === displayFullForm">
            <br>
            <button class="button button--link" v-on:click="displayFullFormControl()" style="color: #919192; font-weight: normal; font-size: 14px">
                Zadat ručně
            </button>
        </template>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import {mapFields} from 'vuex-map-fields';
    import {companyAresData} from '../api/ares';
    import SsvOrderErrorField from '../error/ErrorField';
    import SsvOrderErrorState from '../error/ErrorState';

    export default {
        name:       'SsvOrderBillingInformationIcForm',
        components: {
            SsvOrderErrorState,
            SsvOrderErrorField
        },
        props:      {
            required:        {
                type:    Boolean,
                default: false,
            },
            displayFullForm: {
                type:    Boolean,
                default: false,
            },
            disableAres:     {
                type:    Boolean,
                default: false,
            },
            icOptional:     {
                type:    Boolean,
                default: false,
            },
        },
        data() {
            return {
                processing: false,
                error:      false,
            }
        },
        computed:   {
            ...mapFields('ssvOrder', [
                'billingInformation.name',
                'billingInformation.address',
                'billingInformation.zip',
                'billingInformation.city',
                'billingInformation.identificationNumber',
                'billingInformation.taxIdentificationNumber',
            ]),
        },
        methods:    {
            ...mapActions('ssvOrder', ['setError']),
            loadAresData() {
                if (this.disableAres === true) return;
                this.processing = true;
                this.error = false;
                companyAresData(this.identificationNumber)
                .then((data) => {
                    const { company, street, zip, city, tax_identification_number } = data;
                    this.name = this.name || company;
                    this.address = this.address || street;
                    this.zip = this.zip || zip;
                    this.city = this.city || city;
                    this.taxIdentificationNumber = this.taxIdentificationNumber || tax_identification_number;
                })
                .catch(() => {
                    this.setError({
                        msg: 'Data z ARESu se nepodařilo načíst, zadejte je, prosím, ručně.',
                        key: 'billingInformation.icError'
                    });
                    this.displayFormControl();
                })
                .finally(() => this.processing = false);
            },
            displayFullFormControl() {
                this.$emit('displayFullFormControl');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/billing-information/BillingInformationIcForm.vue